import _ from "lodash";
import {getNormalizedColumnName} from "../../utils/normalizers";
import {FILTER_MODE_IN} from "../../utils/sdmxJson";
import {
  getBestFrequency,
  getDateTimeStrFromTimePeriodColumnVal,
  getTimePeriodColumnValFromDateTimeStr,
  getTreeFilterStrFromObj,
  TREE_FILTER_MAX_LENGTH
} from "./utils";
import {Alert, Button, Col, Form, Modal, Row} from "antd";
import React, {Fragment, useState} from "react";
import {
  MARGIN_MD,
  MODAL_WIDTH_MD,
  SPAN_HALF,
  SPAN_ONE_QUARTER,
  SPAN_THREE_QUARTERS
} from "../../styles/constants";
import Selector from "../selector";
import EnhancedModal from "../enhanced-modal";
import InfiniteScrollDataTable from "../infinite-scroll-data-table";
import {translate} from 'react-i18next';
import LocalizedDatePicker from "../localized-date-picker";
import moment from "moment";

const datePickerProps = {
  format: 'DD/MM/YYYY'
};

const TreeFilterTimePeriod = ({
                                t,
                                tempTPFrom,
                                tempTPTo,
                                treeFilter,
                                isCC,
                                column,
                                columns,
                                callOnColumnValuesChangeWithSpinner,
                                index,
                                isSdmx,
                                disabled,
                                setTPFromTo,
                                usePickers
                              }) => {

  const [isTPFromListVisible, setTPFromListVisible] = useState(false);
  const [isTPToListVisible, setTPToListVisible] = useState(false);

  const freqCol = (columns ||[]).find(({name}) => name === "FREQ" || name === "ID_FREQ");

  const onTimePeriodChange = newFromTo => {

    const callOnColumnValuesChange = () => {

      const values = newFromTo ? [newFromTo.from, newFromTo.to] : [];

      const newTreeFilter = _.cloneDeep(treeFilter);

      const columnName = !isCC ? column.name : getNormalizedColumnName(column.name);

      newTreeFilter[columnName] = {
        mode: FILTER_MODE_IN,
        values
      };

      const colNames = columns.map(({name}) =>
        !isCC ? name : getNormalizedColumnName(name));

      const colIndex = colNames.indexOf(columnName);
      const subsequentColNames = colNames.splice(colIndex + 1);

      // delete filters for subsequent cols
      subsequentColNames.forEach(name => {
        delete newTreeFilter[!isCC ? name : getNormalizedColumnName(name)];
      });

      if (!isCC && getTreeFilterStrFromObj(newTreeFilter, colNames).length > TREE_FILTER_MAX_LENGTH) {
        Modal.error({
          title: t('components.treeFilter.errors.maxLength.title'),
          content: t('components.treeFilter.errors.maxLength.content')
        });
      } else {
        callOnColumnValuesChangeWithSpinner(column.name, values);
      }
    }

    const subsequentColumnNames = columns.slice(index + 1).map(({name}) =>
      !isCC ? name : getNormalizedColumnName(name));
    if (subsequentColumnNames.find(name => treeFilter[name])) {
      Modal.confirm({
        title: t('components.treeFilter.confirms.filterChange.title'),
        content: t('components.treeFilter.confirms.filterChange.content'),
        onOk() {
          callOnColumnValuesChange();
        },
        cancelText: t('commons.buttons.cancel.title')
      })
    } else {
      callOnColumnValuesChange();
    }
  };

  return (
    <Fragment>
      {(
        (isSdmx || isCC) && (
          (tempTPFrom !== null && tempTPTo === null) ||
          (tempTPFrom === null && tempTPTo !== null)
        )
      ) && (
        <Alert
          type="warning"
          showIcon
          message={t('components.treeFilter.warnings.incompleteTimePeriod.title')}
          style={{marginBottom: MARGIN_MD}}
        />
      )}
      {usePickers
        ? (
          <Fragment>
            <Row type="flex" style={{marginBottom: MARGIN_MD}}>
              <Col span={SPAN_HALF}>
                <Form.Item
                  label={t('components.treeFilter.timePeriod.from.title')}
                  labelCol={{span: SPAN_ONE_QUARTER}}
                  wrapperCol={{span: SPAN_THREE_QUARTERS}}
                  className="form-item-required"
                >
                  <LocalizedDatePicker
                    disabled={disabled}
                    {...datePickerProps}
                    onChange={val => {
                      const newFromTo = {
                        from: val ? (val.format("YYYY-MM-DDT00:00:00.000") + "Z") : null,
                        to: tempTPTo || (
                          (treeFilter[column.name] && treeFilter[column.name].values.length > 0)
                            ? treeFilter[column.name].values[1]
                            : (treeFilter[getNormalizedColumnName(column.name)] && treeFilter[getNormalizedColumnName(column.name)].values.length > 0)
                            ? treeFilter[getNormalizedColumnName(column.name)].values[1]
                            : null
                        )
                      }
                      setTPFromTo({
                        tempTPFrom: newFromTo.from,
                        tempTPTo: newFromTo.to
                      });
                      if (newFromTo.from && newFromTo.to) {
                        onTimePeriodChange(newFromTo);
                      } else {
                        onTimePeriodChange(null);
                      }
                    }}
                    value={
                      (treeFilter[column.name] && treeFilter[column.name].values.length > 0)
                        ? moment.utc(treeFilter[column.name].values[0])
                        : (treeFilter[getNormalizedColumnName(column.name)] && treeFilter[getNormalizedColumnName(column.name)].values.length > 0)
                        ? moment.utc(treeFilter[getNormalizedColumnName(column.name)].values[0])
                        : (tempTPFrom ? moment.utc(tempTPFrom) : null)
                    }
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row type="flex" style={{marginBottom: MARGIN_MD}}>
              <Col span={SPAN_HALF}>
                <Form.Item
                  label={t('components.treeFilter.timePeriod.to.title')}
                  labelCol={{span: SPAN_ONE_QUARTER}}
                  wrapperCol={{span: SPAN_THREE_QUARTERS}}
                  className="form-item-required"
                >
                  <LocalizedDatePicker
                    disabled={disabled}
                    {...datePickerProps}
                    onChange={val => {
                      const newFromTo = {
                        from: tempTPFrom || (
                          (treeFilter[column.name] && treeFilter[column.name].values.length > 0)
                            ? treeFilter[column.name].values[0]
                            : (treeFilter[getNormalizedColumnName(column.name)] && treeFilter[getNormalizedColumnName(column.name)].values.length > 0)
                            ? treeFilter[getNormalizedColumnName(column.name)].values[0]
                            : null
                        ),
                        to: val ? (val.format("YYYY-MM-DDT00:00:00.000") + "Z") : null
                      }
                      setTPFromTo({
                        tempTPFrom: newFromTo.from,
                        tempTPTo: newFromTo.to
                      });
                      if (newFromTo.from && newFromTo.to) {
                        onTimePeriodChange(newFromTo);
                      } else {
                        onTimePeriodChange(null);
                      }
                    }}
                    value={
                      (treeFilter[column.name] && treeFilter[column.name].values.length > 0)
                        ? moment.utc(treeFilter[column.name].values[1])
                        : (treeFilter[getNormalizedColumnName(column.name)] && treeFilter[getNormalizedColumnName(column.name)].values.length > 0)
                        ? moment.utc(treeFilter[getNormalizedColumnName(column.name)].values[1])
                        : (tempTPTo ? moment.utc(tempTPTo) : null)
                    }
                  />
                </Form.Item>
              </Col>
            </Row>
          </Fragment>
        )
        : (!isCC || !freqCol || freqCol.filteredValues)
          ? (
            <Fragment>
              <Row type="flex" style={{marginBottom: MARGIN_MD}}>
                <Col span={SPAN_HALF}>
                  <Form.Item
                    label={t('components.treeFilter.timePeriod.from.title')}
                    labelCol={{span: SPAN_ONE_QUARTER}}
                    wrapperCol={{span: SPAN_THREE_QUARTERS}}
                  >
                    <Selector
                      disabled={disabled}
                      selectTitle={t('components.treeFilter.timePeriod.selector.selectButton.title')}
                      resetTitle={t('components.treeFilter.timePeriod.selector.resetButton.title')}
                      onSelect={() => setTPFromListVisible(true)}
                      onReset={() => {
                        const newFromTo = {
                          from: null,
                          to: tempTPTo || (
                            (treeFilter[column.name] && treeFilter[column.name].values.length > 0)
                              ? treeFilter[column.name].values[1]
                              : (treeFilter[getNormalizedColumnName(column.name)] && treeFilter[getNormalizedColumnName(column.name)].values.length > 0)
                              ? treeFilter[getNormalizedColumnName(column.name)].values[1]
                              : null
                          )
                        }
                        setTPFromTo({
                          tempTPFrom: newFromTo.from,
                          tempTPTo: newFromTo.to
                        });
                        if (isSdmx || isCC || newFromTo.to === null) {
                          onTimePeriodChange(null);
                        } else {
                          onTimePeriodChange(newFromTo);
                        }
                      }}
                      value={
                        (treeFilter[column.name] && treeFilter[column.name].values.length > 0)
                          ? treeFilter[column.name].values[0]
                          : (treeFilter[getNormalizedColumnName(column.name)] && treeFilter[getNormalizedColumnName(column.name)].values.length > 0)
                          ? treeFilter[getNormalizedColumnName(column.name)].values[0]
                          : (tempTPFrom || null)
                      }
                      render={val =>
                        (isCC && val !== null)
                          ? getTimePeriodColumnValFromDateTimeStr(val, freqCol ? getBestFrequency(freqCol.filteredValues) : "A")
                          : val
                      }
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row type="flex" style={{marginBottom: MARGIN_MD}}>
                <Col span={SPAN_HALF}>
                  <Form.Item
                    label={t('components.treeFilter.timePeriod.to.title')}
                    labelCol={{span: SPAN_ONE_QUARTER}}
                    wrapperCol={{span: SPAN_THREE_QUARTERS}}
                  >
                    <Selector
                      disabled={disabled}
                      selectTitle={t('components.treeFilter.timePeriod.selector.selectButton.title')}
                      resetTitle={t('components.treeFilter.timePeriod.selector.resetButton.title')}
                      onSelect={() => setTPToListVisible(true)}
                      onReset={() => {
                        const newFromTo = {
                          from: tempTPFrom || (
                            (treeFilter[column.name] && treeFilter[column.name].values.length > 0)
                              ? treeFilter[column.name].values[0]
                              : (treeFilter[getNormalizedColumnName(column.name)] && treeFilter[getNormalizedColumnName(column.name)].values.length > 0)
                              ? treeFilter[getNormalizedColumnName(column.name)].values[0]
                              : null
                          ),
                          to: null
                        }
                        setTPFromTo({
                          tempTPFrom: newFromTo.from,
                          tempTPTo: newFromTo.to
                        });
                        if (isSdmx || isCC || newFromTo.from === null) {
                          onTimePeriodChange(null);
                        } else {
                          onTimePeriodChange(newFromTo);
                        }
                      }}
                      value={
                        (treeFilter[column.name] && treeFilter[column.name].values.length > 0)
                          ? treeFilter[column.name].values[1]
                          : (treeFilter[getNormalizedColumnName(column.name)] && treeFilter[getNormalizedColumnName(column.name)].values.length > 0)
                          ? treeFilter[getNormalizedColumnName(column.name)].values[1]
                          : (tempTPTo || null)
                      }
                      render={val =>
                        (isCC && val !== null)
                          ? getTimePeriodColumnValFromDateTimeStr(val, freqCol ? getBestFrequency(freqCol.filteredValues) : "A")
                          : val
                      }
                    />
                  </Form.Item>
                </Col>
              </Row>
              <EnhancedModal
                visible={isTPFromListVisible || isTPToListVisible}
                width={MODAL_WIDTH_MD}
                title={t('components.treeFilter.timePeriod.valuesModal.title')}
                footer={
                  <Button
                    onClick={() => {
                      setTPFromListVisible(false);
                      setTPToListVisible(false);
                    }}
                  >
                    {t('commons.buttons.close.title')}
                  </Button>
                }
                onCancel={() => {
                  setTPFromListVisible(false);
                  setTPToListVisible(false);
                }}
              >
                <InfiniteScrollDataTable
                  isPaginated={false}
                  noFilter
                  noSort
                  data={
                    column.filteredValues
                      ? column.filteredValues
                        .filter(val => val !== null)
                        .map(val => ({
                          [getNormalizedColumnName(column.name)]: val
                        }))
                      : null
                  }
                  cols={[getNormalizedColumnName(column.name)]}
                  onRowClick={row => {

                    const rowVal = row[getNormalizedColumnName(column.name)];

                    const val = isCC
                      ? getDateTimeStrFromTimePeriodColumnVal(rowVal, isTPToListVisible)
                      : rowVal;

                    let newFromTo;

                    if (isTPFromListVisible) {
                      newFromTo = {
                        from: val,
                        to: tempTPTo
                      };

                      setTPFromListVisible(false);
                      setTPFromTo({
                        tempTPFrom: newFromTo.from
                      });

                    } else {
                      newFromTo = {
                        from: tempTPFrom,
                        to: val
                      };

                      setTPToListVisible(false);
                      setTPFromTo({
                        tempTPTo: newFromTo.to
                      });
                    }

                    if (!isSdmx || (isSdmx && newFromTo.from && newFromTo.to)) {
                      onTimePeriodChange(newFromTo);
                    }
                  }}
                />
              </EnhancedModal>
            </Fragment>
          )
          : null}
    </Fragment>
  );
};

export default translate()(TreeFilterTimePeriod);